"use strict";
/**
 * Created on 03 06 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject"); // tslint:disable:max-classes-per-file

/**
 * <p>Abstract tuple formed by identification of an item and associated {@link RealImpact price impact}.</p>
 *
 * @author JMe
 */


var AbstractReleaseItemPriceImpact =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(AbstractReleaseItemPriceImpact, _DomainObject_1$Domai);

  /**
   * CTor.
   *
   * @param iId {@link AbstractReleaseItem.id}
   * @param realImpact Real impact of an item.
   */
  function AbstractReleaseItemPriceImpact(iId, realImpact) {
    var _this;

    _classCallCheck(this, AbstractReleaseItemPriceImpact);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractReleaseItemPriceImpact).call(this));
    _this.iId = iId;
    _this.realImpact = realImpact;
    return _this;
  }

  return AbstractReleaseItemPriceImpact;
}(DomainObject_1.DomainObject);

exports.AbstractReleaseItemPriceImpact = AbstractReleaseItemPriceImpact;
/**
 * <p>{@link ReleaseItemPriceImpact} represents aggregated {@link RealImpact} for entire {@link ReleaseItem item} (inc. combined impacts of
 * associated {@link PriceZone price zones}).</p>
 *
 * @author JMe
 */

var ReleaseItemPriceImpact =
/*#__PURE__*/
function (_AbstractReleaseItemP) {
  _inherits(ReleaseItemPriceImpact, _AbstractReleaseItemP);

  /**
   * @param iId {@link ReleaseItem.id}
   * @param realImpact Aggregated {@link RealImpact} from all related {@link PriceZone price zones}.
   * @param zImpacts Price impacts related to associated price zones (see {@link ReleaseItem.prices} for more info).
   */
  function ReleaseItemPriceImpact(iId, realImpact, zImpacts) {
    var _this2;

    _classCallCheck(this, ReleaseItemPriceImpact);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseItemPriceImpact).call(this, iId, realImpact));
    _this2.iId = iId;
    _this2.realImpact = realImpact;
    _this2.zImpacts = zImpacts;
    return _this2;
  }

  return ReleaseItemPriceImpact;
}(AbstractReleaseItemPriceImpact);

exports.ReleaseItemPriceImpact = ReleaseItemPriceImpact;
/**
 * <p>{@link ReleaseItemPriceZoneImpact} represents {@link RealImpact} for certain {@link PriceZone price zone}.</p>
 *
 * @author JMe
 */

var ReleaseItemPriceZoneImpact =
/*#__PURE__*/
function (_DomainObject_1$Domai2) {
  _inherits(ReleaseItemPriceZoneImpact, _DomainObject_1$Domai2);

  /**
   * @param zId identification of zone, most probably {@link PriceZone.id}.
   * @param realImpact Price impact related to {@link PriceZone}.
   */
  function ReleaseItemPriceZoneImpact(zId, realImpact) {
    var _this3;

    _classCallCheck(this, ReleaseItemPriceZoneImpact);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseItemPriceZoneImpact).call(this));
    _this3.zId = zId;
    _this3.realImpact = realImpact;
    return _this3;
  }

  return ReleaseItemPriceZoneImpact;
}(DomainObject_1.DomainObject);

exports.ReleaseItemPriceZoneImpact = ReleaseItemPriceZoneImpact;